import WebApp from '@twa-dev/sdk';

import { type Responder } from '@/entities/playdeck/lib/respond-with-message';
import { validateMessageData } from '@/entities/playdeck/lib/validate-message-data';
import { warnIncorrectValues } from '@/entities/playdeck/lib/warn-incorrect-values';
import { Method } from '@/entities/playdeck/types';

import { openLink } from './share/open-link';

const isInvoiceLink = (url: string) => url.includes('t.me/$');

export const openTgLinkHandler = (value: any, respond: Responder) => {
  const { url } = value;

  if (!validateMessageData({ value: url ?? value, allowedTypes: ['string'] })) {
    warnIncorrectValues(Method.OPEN_TG_LINK, 'url', ['string']);
  }

  if (isInvoiceLink(url ?? value)) {
    const eventHandler = (status: 'paid' | 'cancelled' | 'failed' | 'pending') => {
      respond({ method: Method.INVOICE_CLOSED, value: { status } });
    };

    WebApp.openInvoice(url ?? value, eventHandler);
    return;
  }

  openLink(url ?? value);
};
